import styled from 'styled-components'

export const BlankSlateContainer = styled.div`
  display: flex;
  color: ${({ theme, color }) => color || theme.cor54}!important;
  justify-content: space-evenly;
  flex-direction: column;
  height: ${({ centralize }) => centralize && '100vh'};
  margin-top: ${({ marginTop }) => marginTop && `${marginTop}px`};
`
export const BlankSlateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Icon = styled.div`
  img {
    width: ${({ size = 100 }) => `${(60 * size) / 100}px`} !important;
    height: ${({ size = 100 }) => `${(60 * size) / 100}px`} !important;
    margin-bottom: ${({ marginBottom }) =>
      marginBottom && `${marginBottom}px !important`};
  }
`

export const Title = styled.div`
  font-size: ${({ size = 100 }) => `${(32 * size) / 100}px`} !important;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
`

export const SubTitle = styled.div`
  margin-top: 20px;
  font-size: ${({ size = 100 }) => `${(20 * size) / 100}px`} !important;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
  width: max-content;
`
